export default "__VITE_PUBLIC_ASSET__e92f5dad__"